import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'

import config from '../../../config'
import PortalLinkImageForm from './PortalLinkImageForm'

class PortalLinkImageFormContainer extends React.Component {
  state = {}

  initialValues = values => {
    console.log(values)
    return {
      title: config.getLangText(),
      ...values,
    }
  }

  handleSubmit = async (values, actions) => {
    if (this.props.onRequestClose) {
      this.props.onRequestClose(values)
    }
    actions.setSubmitting(false)
  }

  handleValidate = (values, props) => {
    var errors = {}
    return errors
  }

  render() {
    return (
      <PortalLinkImageForm
        initialValues={this.initialValues(_.get(this.props.params, 'link'))}
        onValidate={this.handleValidate}
        onSubmit={this.handleSubmit}
        onRequestClose={() => this.props.onRequestClose(null)}
      />
    )
  }
}

export default connect(({ portal, info }) => ({
  language: info.language,
  portalID: portal._id,
  links: portal.links,
}))(PortalLinkImageFormContainer)



// WEBPACK FOOTER //
// ./src/components/templates/portal-link/PortalLinkImageFormContainer.js